// 新增场景
<template>
  <div class="main">
    <van-dialog
      v-model="isShow"
      :title="isTitle"
      :showConfirmButton="false"
      class="dialog_box"
      width="78%"
    >
      <div class="modal_main">
        <div class="modal_box">
          <img
            class="head_img"
            src="./../../assets/images/scene/pic_header.png"
            alt=""
          />
          <img
            class="text_img"
            @click="onCancel"
            src="./../../assets/images/scene/text_add.png"
            alt=""
          />
          <input
            type="text"
            v-model="form.scene_name"
            class="ipt"
            maxlength="4"
            @input="handleChange"
            placeholder="请创建四字场景名称"
          />

          <textarea
            v-model="form.scene_desc"
            class="ipt ipt_textarea"
            @input="handleChange"
            maxlength="150"
            placeholder="请简单描述使用场景，不超过150字"
          >
          </textarea>

          <van-button
            class="default_btn mgt20"
            @click="onSubmit"
            :disabled="!isDisabled"
            color="#4BFFF2"
            round
            >提交
          </van-button>
          <img
            class="close_img"
            @click="onCancel"
            src="./../../assets/images/icon_close_b.png"
            alt=""
          />
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  name: "AddScene",
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    isTitle: {
      type: String,
      default: "",
    },
    addType: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      form: {
        scene_name: "",
        scene_desc: "",
      },
      isDisabled: false,
    };
  },
  mounted() {},
  methods: {
    // 新增场景
    onSubmit() {
      this.$emit("addScene", this.form);
      this.onCancel();
    },
    onCancel() {
      this.$emit("update:isShow", false);
      this.form = {
        scene_name: "",
        scene_desc: "",
      };
      this.isDisabled = false;
    },

    handleChange() {
      this.isDisabled =
        this.form.scene_name.length > 0 && this.form.scene_desc.length > 0;
    },
  },
};
</script>

<style lang="less" scoped>
.dialog_box {
  background-color: transparent;
}
.main {
  /deep/ .van-dialog {
    overflow: inherit;
  }
}
.modal_main {
  position: relative;
  min-height: 420px;
  background: url("./../../assets/images/scene/back_add.png") no-repeat 100%
    100%;
  background-size: cover;
  .modal_box {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 0 25px;
    padding-top: 40%;
    .ipt {
      position: absolute;
      box-sizing: border-box;
      top: 80px;
      width: 80%;
      background: #5257cf;
      border: 1px solid #6f87ff;
      height: 36px;
      text-align: center;
      line-height: 36px;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #ffffff;
    }
    .ipt_textarea {
      text-align: justify;
      top: 135px;
      min-height: 180px;
      padding: 10px;
      padding-left: 14px;
      resize: none;
      font-weight: normal;
      //   color: #6f87ff;
      line-height: 20px;
    }
    .default_btn {
      position: absolute;
      width: 68%;
      bottom: 30px;
      height: 37px;
      border-radius: 18px;

      .van-button__text {
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #111111;
        line-height: 20px;
      }
    }
    .head_img {
      width: 55px;
      height: 55px;
      position: absolute;
      top: -26px;
    }
    .text_img {
      position: absolute;
      width: 88px;
      height: 20px;
      top: 44px;
    }
    .close_img {
      position: absolute;
      width: 30px;
      height: 30px;
      bottom: -60px;
    }
  }
  input::-webkit-input-placeholder {
    /* WebKit browsers */
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #6f87ff;
  }
  input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #6f87ff;
  }
  input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #6f87ff;
  }
  input:-ms-input-placeholder {
    /* Internet Explorer 10+ */
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #6f87ff;
  }
  textarea::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #6f87ff;
    text-align: justify;
  }
  textarea:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #6f87ff;
    text-align: justify;
  }
  textarea::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #6f87ff;
    text-align: justify;
  }
  textarea::-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: #6f87ff;
    text-align: justify;
  }
  input[type="text"] {
    padding-top: 4px;
    -webkit-appearance: none;
  }
  textarea {
    text-align: justify;
    -webkit-appearance: none;
  }
}
</style>